import { Reducer, useCallback, useReducer } from 'react';
import { SearchState } from 'types/Search';

type SearchStateChangeAction =
  | { type: 'FETCH_MORE' }
  | {
      type: 'NORMAL';
      newState: Partial<Omit<SearchState, 'isFetchingMore' | 'from'>>;
    }
  | { type: 'BACKGROUND_REFETCH' };

export const useSearchStateReducer = (
  pageSize: number,
  initialState: SearchState,
  hideOldTableIndicator?: boolean
) => {
  const searchStateReducer: Reducer<SearchState, SearchStateChangeAction> =
    useCallback(
      (prevState, action) => {
        switch (action.type) {
          case 'FETCH_MORE':
            return {
              ...prevState,
              from: prevState.from + pageSize,
              isFetchingMore: true,
              hideLoadingIndicator: !!hideOldTableIndicator
            };
          case 'NORMAL':
            return {
              ...initialState,
              ...prevState,
              from: 0,
              size: pageSize,
              hideLoadingIndicator: false,
              isFetchingMore: false,
              loadMore: false,
              ...action.newState
            };
          case 'BACKGROUND_REFETCH':
            return {
              ...prevState,
              hideLoadingIndicator: true,
              isFetchingMore: false,
              loadMore: false
            };
          default:
            return prevState;
        }
      },
      [hideOldTableIndicator, initialState, pageSize]
    );

  return useReducer(searchStateReducer, initialState);
};
